<template>
  <v-scale-screen :width="1280" :height="680" :auto-scale="{ x: true, y: true }">
    <div id="index" ref="appRef">
      <div id="cusNum" class="cusNum1">{{ customerName }}</div>
      <div class="bg">
        <dv-loading v-if="loading">Loading...</dv-loading>
        <div v-else class="host-body">
          <div class="header-box">
            <div class="d-flex jc-center project-title">
              医用织物智慧数据管理中心
            </div>
            <div
              class="d-flex jc-center project-title project-box"
              style="padding-top: 0"
            >
              <div class="project-sub-title">
                荣获国家高新技术企业、深圳专精特新企业双授牌
              </div>
            </div>
            <div class="react-right mr-4 react-l-s top-date">
              <span class="react-after"></span>
              <span class="text fs-lg"
                >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span
              >
            </div>
            <div class="custom-seamless">
              <div class="text fs-lg text_title">
                让科技赋能健康医疗服务，助力医院降本增效
              </div>
            </div>
            <div class="user-info text-info-1">
              <i class="el-icon-user-solid"></i>
              <el-tooltip placement="bottom" effect="light">
                <template #content>
                  <span
                    class="loginOut"
                    @click="loginOut"
                    style="cursor: pointer"
                  >退出登录</span>
                </template>
                <span class="username">{{ username }}</span>
              </el-tooltip>
            </div>
          </div>

          <div class="body-box">
            <div class="body-item-top">
              <topCenterInfo ref="topCenterInfo" />
            </div>

            <div class="body-grid">
              <!-- 宸︿晶鍒楋細涓婅 + 涓嬭 -->
              <div class="body-column-left">
                <div class="body-item-left-top">
                  <dv-border-box-13 :reverse="true" ref="centerLeft1">
                    <centerLeft1 />
                  </dv-border-box-13>
                </div>
                <div class="body-item-left-bottom">
                  <dv-border-box-13 ref="centerRight2">
                    <rightCenter />
                  </dv-border-box-13>
                </div>
              </div>

              <!-- 涓棿鍒楋細鍒嗕负涓婁笅涓よ -->
              <div class="body-column-center">
                <!-- 涓婂崐閮ㄥ垎锛氬尰闄㈢粐鐗╂祦閫氬疄鏃舵暟鎹?-->
                <dv-border-box-13 ref="centerTableFull" class="center-item">
                  <centerTable title="医院织物流通实时数据（件）" />
                </dv-border-box-13>
                <!-- 涓嬪崐閮ㄥ垎锛氳繎涓€骞存礂娑ら噺瓒嬪娍 -->
                <!-- <dv-border-box-13 ref="washingVolumeIndex2" class="center-item">
                  <washingVolumeIndex2 />
                </dv-border-box-13> -->
              </div>

              <!-- 鍙充晶鍒楋細涓婅 + 涓嬭 -->
              <div class="body-column-right">
                <div class="body-item-right-top">
                  <dv-border-box-13 ref="rightTop">
                    <hospitalRanking />
                  </dv-border-box-13>
                </div>
                <div class="body-item-right-bottom">
                  <dv-border-box-13 ref="rightBottom">
                    <washingVolume />
                  </dv-border-box-13>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-scale-screen>
</template>

<script>
// import drawMixin from "../utils/drawMixin";
import { formatTime } from "../utils/index.js";

import centerLeft1 from "./centerLeftIndex1";
import centerRight2 from "./centerRight2";
import centerLeftBottom from "./centerLeftBottom";
import hospitalRanking from "./index2/hospitalRanking";

import summaryList from "./summaryList";
import centerRight1 from "./centerRight1";
import bottomLeft from "./bottomLeft";
// import rentalBed from "../components/rentalBed";
import customerDetails from "../components/customerDetails";
import washingVolume from "../components/washingVolume.vue";
import centerTable from "../components/centerTable.vue";
// import washingVolumeIndex2 from "../components/washingVolumeIndex2.vue";

import rightTop from "./rightTop";
import rightCenter from "./rightCenter";
import rightBottom from "./rightBottom";
import topCenterInfo from "./topPayInfo/topPayInfo";
// import EchartsMap from "../components/echartsMap/echartsData.vue";
import VScaleScreen from "../utils/viewScreen.vue";
import * as Api from "../api/index.js";
export default {
  // mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      decorationColor: ["#568aea", "#000000"],
      username: "",
      customerList: [],
      customerName: "",
    };
  },
  components: {
    VScaleScreen,
    topCenterInfo,
    centerLeft1,
    hospitalRanking,
    // centerRight2,
    // centerLeftBottom,
    // customerDetails,

    // summaryList,
    // centerRight1,
    // bottomLeft,
    // rentalBed,
    washingVolume,
    centerTable,
    // washingVolumeIndex2,

    // rightTop,
    rightCenter,
    // rightBottom,
    // EchartsMap,
  },
  watch: {
    "$store.state.app.sidebar.opened"() {
      setTimeout(() => {
        // 鍙皟鐢ㄥ疄闄呭瓨鍦ㄧ殑缁勪欢鐨刬nitWH鏂规硶
        if (this.$refs.topCenterInfo) {
          this.$refs.topCenterInfo.initWH();
        }
        if (this.$refs.centerLeft1) {
          this.$refs.centerLeft1.initWH();
        }

        if (this.$refs.centerTableFull) {
          this.$refs.centerTableFull.initWH();
        }
        // if (this.$refs.washingVolumeIndex2) {
        //   this.$refs.washingVolumeIndex2.initWH();
        // }
        if (this.$refs.rightTop) {
          this.$refs.rightTop.initWH();
        }
        if (this.$refs.rightBottom) {
          this.$refs.rightBottom.initWH();
        }
        // 濡傛灉rightCenter缁勪欢瀛樺湪锛屼篃娣诲姞缂╂斁鏀寔
        if (this.$refs.rightCenter) {
          this.$refs.rightCenter.initWH();
        }
      }, 300);
    },
  },
  mounted() {
    let info = localStorage.getItem("userInfo");
    if (info) {
      this.customerName = JSON.parse(info).customerName;
    }

    this.username = JSON.parse(localStorage.getItem("userInfo"))?.username;
    let customerId = JSON.parse(localStorage.getItem("userInfo")).customerId;
    console.log(customerId);
    // 鍙湁杩愯惀鎵嶈兘璁块棶杩欎釜椤甸潰
    if (!customerId) {
      this.getCustomerList();
      this.timeFn();
      this.cancelLoading();
    } else {
      this.$router.push("/index2");
    }

    // alert(window.innerWidth + '*' + window.innerHeight)
    console.log("uuuuuuuuuuuu", JSON.parse(localStorage.getItem("userInfo")));
    // this.getCustomerList()
    this.timeFn();
    this.cancelLoading();
    this.username = JSON.parse(localStorage.getItem("userInfo"))?.username;

    // 璁剧疆鏍囬
    const customerName = new URLSearchParams(
      window.location.hash.split("?")[1] || "",
    ).get("customerName");
    if (customerName) {
      document.title = `${customerName}（医用织物数字化平台）`;
    } else {
      document.title = "医用织物数字化平台";
    }

    // add window resize listener
    this.handleResize = this.debounce(() => {
      this.refreshAllComponents();
    }, 300);

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    clearInterval(this.timing);
    // remove window resize listener
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    async loginOut() {
      this.$confirm("确认退出系统吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          await Api.loginOut();
          localStorage.removeItem("userInfo");
          localStorage.removeItem("Authorization");
          localStorage.removeItem("category_page_data");
          // localStorage.removeItem('accountPsw')
          localStorage.clear();
          loading.close();
          this.$message({
            type: "success",
            message: "退出成功",
          });

          this.$router.push("/");
        })
        .catch(() => {});
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async getCustomerList() {
      const res = await Api.selectCustomer();
      res.data.unshift({
        id: 0,
        name: "全部医院",
      });
      this.customerList = res.data;
      // console.log('fdd',localStorage.getItem('userInfo'))
      if (localStorage.getItem("userInfo")) {
        let info = JSON.parse(localStorage.getItem("userInfo"));
        this.customerId = info.customerId;
      }
    },
    debounce(fn, delay = 300) {
      let timer = null;
      return (...args) => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    refreshAllComponents() {
      const refs = [
        "topCenterInfo",
        "centerLeft1",
        "centerTableFull",
        "rightTop",
        "rightBottom",
        "rightCenter",
      ];
      refs.forEach((refName) => {
        const target = this.$refs[refName];
        if (target && typeof target.initWH === "function") {
          target.initWH();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";
#cusNum {
  //font-weight: bold;
  font-size: 22px;
  position: fixed;
  width: auto;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 9%;
  z-index: 999;
  //border: 0.5px solid #00cdff;
  padding: 6px 20px;
  border-radius: 10px;
  span {
    color: #00cdff;
  }
}
.centerBottom {
  height: 28vh;
}

// 涓棿鍒楀竷灞€锛氫笂涓嬩袱琛岋紝鍚勫崰50%
.body-column-center {
  display: flex;
  flex-direction: column;
  height: 100%;

  .center-item {
    flex: 1;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>






